// extracted by mini-css-extract-plugin
module.exports = {"toggle":"languageSwitcher_toggle__gKKNw","singleLocale":"languageSwitcher_singleLocale__lIb1p"};